/**
 * Este archivo es para manejar los errores de upgrade voucher en la redencion de vouchers
 * la respuesta de regresar un status de 200 e incluye las redenciones con un success con valor de true o false
 * y con un reason el cual incluira alguno de los codigos de error de cms que son los objetos del arreglo upgradeVoucherErrors,
 * cada objeto tiene actionable que sera ABORT, CONTINUE, FIX o RETRY para mostrar el modal que se pide en la tarjeta,
 * estos errores no se metricaran ya que como tal no hay un error de api, solamente por alguna rason no se hizo la redencion del voucher.
 */
export const upgradeVoucherErrors = {
  'ERR.UB.UPGRADE_VOUCHER.CRIS_TIMEOUT': {
    actionable: 'ABORT',
    id: 'ERR.UB.UPGRADE_VOUCHER.CRIS_TIMEOUT',
    title : 'ERR.UB.UPGRADE_VOUCHER.CRIS_TIMEOUT',
    type: 'abortModal',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.SESSION_ERROR': {
    actionable: 'ABORT',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.SESSION_ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.SESSION_ERROR',
    type: 'abortModal',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.UPGRADE_RESERVATION_ANCILLARY_ERROR': {
    actionable: 'ABORT',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.UPGRADE_RESERVATION_ANCILLARY_ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.UPGRADE_RESERVATION_ANCILLARY_ERROR',
    type: 'abortModal',
  },
  'ERR.UC.UPGRADE_VOUCHER.BASE_CRIS_SERVICE_NOTAVAILABLE': {
    actionable: 'ABORT',
    id: 'ERR.UC.UPGRADE_VOUCHER.BASE_CRIS_SERVICE_NOTAVAILABLE',
    title : 'ERR.UC.UPGRADE_VOUCHER.BASE_CRIS_SERVICE_NOTAVAILABLE',
    type: 'abortModal',
  },
  'ERR.UC.UPGRADE_VOUCHER.BASE_SABRE_SERVICE_NOTAVAILABLE': {
    actionable: 'ABORT',
    id: 'ERR.UC.UPGRADE_VOUCHER.BASE_SABRE_SERVICE_NOTAVAILABLE',
    title : 'ERR.UC.UPGRADE_VOUCHER.BASE_SABRE_SERVICE_NOTAVAILABLE',
    type: 'abortModal',
  },

  // CONTINUE
  'ERR.UB.UPGRADE_VOUCHER.ACCOUNT_NOT_ACTIVE': {
    actionable: 'CONTINUE',
    id: 'ERR.UB.UPGRADE_VOUCHER.ACCOUNT_NOT_ACTIVE',
    title : 'ERR.UB.UPGRADE_VOUCHER.ACCOUNT_NOT_ACTIVE',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER.ACCOUNT_NOT_FOUND': {
    actionable: 'CONTINUE',
    id: 'ERR.UB.UPGRADE_VOUCHER.ACCOUNT_NOT_FOUND',
    title : 'ERR.UB.UPGRADE_VOUCHER.ACCOUNT_NOT_FOUND',
    type: 'noneAction',
  },
  'ERR.UC.UPGRADE_VOUCHER.NOT_ACTIVE_CARD': {
    actionable: 'CONTINUE',
    id: 'ERR.UC.UPGRADE_VOUCHER.NOT_ACTIVE_CARD',
    title : 'ERR.UC.UPGRADE_VOUCHER.NOT_ACTIVE_CARD',
    type: 'noneAction',
  },

  // FIX
  'ERR.UB.UPGRADE_VOUCHER.GET_VOUCHER_ERROR': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER.GET_VOUCHER_ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER.GET_VOUCHER_ERROR',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER.INVALID_VOUCHER_CODE': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER.INVALID_VOUCHER_CODE',
    title : 'ERR.UB.UPGRADE_VOUCHER.INVALID_VOUCHER_CODE',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.COLLECTMISCFEE__ERROR': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.COLLECTMISCFEE__ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.COLLECTMISCFEE__ERROR',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.GET_RESERVATION_ERROR': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.GET_RESERVATION_ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.GET_RESERVATION_ERROR',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.INVALID_AIRLINE': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.INVALID_AIRLINE',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.INVALID_AIRLINE',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.PAY_ANCILLARY_ERROR': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.PAY_ANCILLARY_ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.PAY_ANCILLARY_ERROR',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.SEGMENT_CLASS_SERVICE_ERROR': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.SEGMENT_CLASS_SERVICE_ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.SEGMENT_CLASS_SERVICE_ERROR',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.SEGMENT_DEPARTURE_DATE_ERROR': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.SEGMENT_DEPARTURE_DATE_ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.SEGMENT_DEPARTURE_DATE_ERROR',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.SEGMENT_NOT_FOUND': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.SEGMENT_NOT_FOUND',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.SEGMENT_NOT_FOUND',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.UPGRADE_RESERVATION_ERROR': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.UPGRADE_RESERVATION_ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.UPGRADE_RESERVATION_ERROR',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER.UPDATE_VOUCHER_ERROR': {
    actionable: 'FIX',
    id: 'ERR.UB.UPGRADE_VOUCHER.UPDATE_VOUCHER_ERROR',
    title : 'ERR.UB.UPGRADE_VOUCHER.UPDATE_VOUCHER_ERROR',
    type: 'noneAction',
  },

  // RETRY
  'ERR.UB.UPGRADE_VOUCHER.INVALID_HEADERS': {
    actionable: 'RETRY',
    id: 'ERR.UB.UPGRADE_VOUCHER.INVALID_HEADERS',
    title : 'ERR.UB.UPGRADE_VOUCHER.INVALID_HEADERS',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER.INVALID_REQUEST_GET': {
    actionable: 'RETRY',
    id: 'ERR.UB.UPGRADE_VOUCHER.INVALID_REQUEST_GET',
    title : 'ERR.UB.UPGRADE_VOUCHER.INVALID_REQUEST_GET',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER.INVALID_REQUEST_PUT': {
    actionable: 'RETRY',
    id: 'ERR.UB.UPGRADE_VOUCHER.INVALID_REQUEST_PUT',
    title : 'ERR.UB.UPGRADE_VOUCHER.INVALID_REQUEST_PUT',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.INVALID_HEADERS':{
    actionable: 'RETRY',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.INVALID_HEADERS',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.INVALID_HEADERS',
    type: 'noneAction',
  },
  'ERR.UB.UPGRADE_VOUCHER_SABRE.INVALID_REQUEST_POST': {
    actionable: 'RETRY',
    id: 'ERR.UB.UPGRADE_VOUCHER_SABRE.INVALID_REQUEST_POST',
    title : 'ERR.UB.UPGRADE_VOUCHER_SABRE.INVALID_REQUEST_POST',
    type: 'noneAction',
  },
  'ERR.UC.UPGRADE_VOUCHER.INVALID_HEADERS': {
    actionable: 'RETRY',
    id: 'ERR.UC.UPGRADE_VOUCHER.INVALID_HEADERS',
    title : 'ERR.UC.UPGRADE_VOUCHER.INVALID_HEADERS',
    type: 'noneAction',
  },
  'ERR.UC.UPGRADE_VOUCHER.INVALID_REQUEST_GET': {
    actionable: 'RETRY',
    id: 'ERR.UC.UPGRADE_VOUCHER.INVALID_REQUEST_GET',
    title : 'ERR.UC.UPGRADE_VOUCHER.INVALID_REQUEST_GET',
    type: 'noneAction',
  },
  'ERR.UC.UPGRADE_VOUCHER.INVALID_REQUEST_POST': {
    actionable: 'RETRY',
    id: 'ERR.UC.UPGRADE_VOUCHER.INVALID_REQUEST_POST',
    title : 'ERR.UC.UPGRADE_VOUCHER.INVALID_REQUEST_POST',
    type: 'noneAction',
  },
  'ERR.UC.UPGRADE_VOUCHER.INVALID_VOUCHER_NUMBER': {
    actionable: 'RETRY',
    id: 'ERR.UC.UPGRADE_VOUCHER.INVALID_VOUCHER_NUMBER',
    title : 'ERR.UC.UPGRADE_VOUCHER.INVALID_VOUCHER_NUMBER',
    type: 'noneAction',
  },
  'ERR.UC.UPGRADE_VOUCHER.TOKEN_REQUIRED': {
    actionable: 'RETRY',
    id: 'ERR.UC.UPGRADE_VOUCHER.TOKEN_REQUIRED',
    title : 'ERR.UC.UPGRADE_VOUCHER.TOKEN_REQUIRED',
    type: 'noneAction',
  },
};